var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "deliverable-status-overview" }, [
    _c(
      "ul",
      { staticClass: "status-bar" },
      _vm._l(_vm.deliverable.tasks, function(task) {
        return _c("li", {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover.html",
              modifiers: { hover: true, html: true }
            }
          ],
          key: "deliverable-status-overview-" + task.id,
          style: { backgroundColor: _vm.taskColor(task) },
          attrs: { title: _vm.taskTitle(task) }
        })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }